export default {
  decimal: ',',
  thousands: '.',
  precision: 2,
  masked: false,
};
